import React from "react";
import { formatTime } from "../helpers/helper";
import SymantoAvatar from "../helpers/SymantoAvatar";

interface CallEndedBannerProps {
	durationSeconds: number;
}

const CallEndedBanner: React.FC<CallEndedBannerProps> = ({
	durationSeconds,
}) => {
	return (
		<div className="flex items-center gap-3 bg-white rounded-2xl shadow-md px-4 py-3 w-full max-w-sm">
			<SymantoAvatar size={40} />
			<p className="text-sm md:text-base text-gray-800">
				Call ended : {formatTime(durationSeconds)} minutes
			</p>
		</div>
	);
};

export default CallEndedBanner;
